import Index from "@/pages/Projects/Index.vue";
import Past from "@/pages/Projects/Past.vue";
import Show from "@/pages/Projects/Show.vue";
import RequestAccess from "@/pages/Projects/RequestAccess.vue";

export default [
  {
    name: 'projects',
    path: '/projects',
    component: Index,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
      ],
      icon: 'calendar',
      title: 'Current Projects',
    },
  },
  {
    name: 'projects/show',
    path: '/projects/:projectId',
    component: Show,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
        'projects/current',
        'projects/show',
      ],
      icon: 'calendar-clock',
      useModelForTitle: 'project',
    },
  },
  {
    name: 'projects/bid-packages/show',
    path: '/projects/:projectId/bid-packages/:bidPackageId',
    component: Show,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
        'projects/current',
        'projects/show',
      ],
      icon: 'calendar-clock',
      useModelForTitle: 'project',
    },
  },
  {
    path: '/projects/:projectId/show',
    redirect: (to: any) => ({
      name: 'projects/show',
      params: { projectId: to.params.projectId },
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    name: 'projects/request-access',
    path: '/projects/:projectId/request-access',
    component: RequestAccess,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
        'projects/current',
        'projects/request-access',
      ],
      icon: 'calendar-clock',
      useModelForTitle: 'project',
    },
  },
  {
    name: 'projects/current',
    path: '/projects',
    component: Index,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
      ],
      icon: 'calendar-clock',
      title: 'Current Projects',
    },
  },
  {
    name: 'projects/past',
    path: '/projects/past',
    component: Past,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
      ],
      icon: 'calendar-check',
      title: 'Past Projects',
    },
  },
  {
    name: 'projects/past/show',
    path: '/projects/past/:projectId',
    component: Show,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
        'projects/past',
        'projects/past/show',
      ],
      icon: 'calendar-check',
      useModelForTitle: 'project',
    },
  },
  {
    name: 'projects/past/bid-packages/show',
    path: '/projects/past/:projectId/bid-packages/:bidPackageId',
    component: Show,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
        'projects/past',
        'projects/past/show',
      ],
      icon: 'calendar-check',
      useModelForTitle: 'project',
    },
  },
  {
    path: '/projects/past/:projectId/show',
    redirect: (to: any) => ({
      name: 'projects/past/show',
      params: { projectId: to.params.projectId },
      query: to.query,
      hash: to.hash,
    }),
  },
  {
    name: 'projects/past/request-access',
    path: '/projects/past/:projectId/request-access',
    component: RequestAccess,
    meta: {
      requiresAuth: true,
      breadcrumbs: [
        'projects/past',
        'projects/past/request-access',
      ],
      icon: 'calendar-clock',
      useModelForTitle: 'project',
    },
  },
]
